<app-announcement-bar></app-announcement-bar>
<app-navbar-user [active]="'dashboard'"></app-navbar-user>
<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
<div class="container-fluid dashboard p-5 main-content">
    <div class="row">
        <div class="col-md-12 mb-3">
            <div class="d-md-flex align-items-center justify-content-between d-block">
                <div class="d-flex align-items-center">
                    <h2 class="m-0 page-title"><i class="bx bx-qr-scan btn-icon"></i> Redeem a Code</h2>
                    <div class="d-sm-block d-md-inline mt-1 mb-3 mt-md-0 mb-md-0">

                    </div>
                </div>
            </div>
            <div class="row" *ngIf="!libraryCode">
                <div class="col-md-4 pt-4">
                    <form #codeForm="ngForm" (ngSubmit)="onCheckCode(codeForm)" *ngIf="!isLoading">
                        <div class="form-group mb-4">
                            <label for="code" class="form-label">Enter the 20 Character code</label>
                            <input type="text" id="code" class="form-control" [ngClass]="{ 'is-invalid': error }"
                                [(ngModel)]="code" name="code" placeholder="XXXXX-XXXXX-XXXXX-XXXXX" required
                                autocomplete="off" />
                        </div>

                        <div class="form-text text-danger" *ngIf="error">
                            <p>{{ error }}</p>
                        </div>

                        <button type="submit" [disabled]="!codeForm.valid"
                            class="btn btn-dark w-100 rounded-pill shadow-sm">
                            Check Code
                        </button>
                    </form>
                </div>
            </div>

            <div class="row" *ngIf="libraryCode">
                <div class="col-md-6 mt-3">
                    <div *ngFor="let item of libraryCode.items">
                        <h2>{{item.title}}</h2>
                        <p>{{item.description}}</p>
                        <img [src]="item.thumb ? environment.mediaUrl +  '/assets/thumbs/' + item.thumb : 'https://placehold.co/600x400'"  alt="Thumbnail for {{item.title}}" width="100%">
                    </div>
                    <hr>
                    <div>
                        <form #confirmForm="ngForm" (ngSubmit)="onConfirm(confirmForm)" *ngIf="!isLoading">

                            <div class="form-text text-danger" *ngIf="error">
                                <p>{{ error }}</p>
                            </div>

                            <button type="submit" class="btn btn-dark w-100 rounded-pill shadow-sm">
                                Add to Library
                            </button>
                        </form>
                    </div>
                </div>
            </div>



        </div>
    </div>
</div>

<app-footer></app-footer>